<section class="steps-tutorial">
	<button class="steps-tutorial__close-button" (click)="onCloseTutorial()">
		<i class="bi bi-arrow-left"></i>
	</button>
	<div class="steps-tutorial__images">
		<img
			*ngFor="let image of currentTutorialStep.images"
			[class]="image.class"
			[src]="image.path"
			[alt]="image.alt" />
	</div>
	<section class="steps-tutorial__steps">
		<div>
			<h2>Paso{{ currentStep }}</h2>
			<h1>{{ currentTutorialStep.title }}</h1>
			<p [innerHTML]="currentTutorialStep.description"></p>
		</div>
		<section class="steps-tutorial__progress">
			<button
				*ngIf="!isStepFirstStep"
				class="steps-tutorial__progress__step-back-button"
				(click)="onPreviousStep()">
				<i class="bi bi-arrow-left"></i>
			</button>
			<div class="steps-tutorial__progress__steps">
				<div
					*ngFor="let step of steps"
					[ngClass]="{ active: currentStep === step.stepNumber }"></div>
			</div>
			<button
				*ngIf="!isStepLastStep"
				class="steps-tutorial__progress__step-next-button"
				(click)="onNextStep()">
				<i class="bi bi-arrow-right"></i>
			</button>
			<button
				*ngIf="isStepLastStep"
				class="steps-tutorial__progress__finish-tutorial-button"
				(click)="onFinishTutorial()">
				¡Comencemos!
			</button>
		</section>
	</section>
</section>
